'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGoogleTagManager = require('react-google-tag-manager');

var _reactGoogleTagManager2 = _interopRequireDefault(_reactGoogleTagManager);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GoogleTagManager = function (_Component) {
    (0, _inherits3.default)(GoogleTagManager, _Component);

    function GoogleTagManager() {
        (0, _classCallCheck3.default)(this, GoogleTagManager);
        return (0, _possibleConstructorReturn3.default)(this, (GoogleTagManager.__proto__ || (0, _getPrototypeOf2.default)(GoogleTagManager)).apply(this, arguments));
    }

    (0, _createClass3.default)(GoogleTagManager, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var dataLayerName = this.props.dataLayerName || 'dataLayer';
            var scriptId = this.props.scriptId || 'react-google-tag-manager-gtm';

            if (!window[dataLayerName]) {
                var gtmScriptNode = document.getElementById(scriptId);

                /* eslint-disable no-eval */
                eval(gtmScriptNode.textContent);
                /* eslint-enable no-eval */
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var gtm = (0, _reactGoogleTagManager2.default)({
                additionalEvents: this.props.additionalEvents || {},
                dataLayerName: this.props.dataLayerName || 'dataLayer',
                id: this.props.gtmId,
                previewVariables: this.props.previewVariables || false
            });

            return (0, _jsx3.default)(_react.Fragment, {}, void 0, (0, _jsx3.default)('div', {}, void 0, gtm.noScriptAsReact()), (0, _jsx3.default)('div', {
                id: this.props.scriptId || 'react-google-tag-manager-gtm'
            }, void 0, gtm.scriptAsReact()));
        }
    }]);
    return GoogleTagManager;
}(_react.Component);

exports.default = GoogleTagManager;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GTM/GoogleTagManager.js
// module id = z3uV
// module chunks = 57